export default __webpack_public_path__ + "static/media/58-min.610b9afa.png";